import api from 'api/apiInstance';

import type { SuitabilityLetterResponse } from '../types';

export function clientCaseSuitabilityLettersGenerateApi(path: string) {
  return {
    path,
    // 202 Accepted — the AI draft is generated by a background worker
    // (metered AI call). The response carries the `initialized` record;
    // consumers poll `last` until `completed` (or `failed`).
    POST: () =>
      api.post<SuitabilityLetterResponse>(path, undefined, {
        // Custom interceptor flag — typed in src/types/axiosSkipRedirect.d.ts.
        skipRedirect: true,
      }),
  };
}
